import { useHubble } from '@seek/hubble';
import { useTranslations } from '@vocab/react';
import { ButtonLink, IconNewWindow, Actions } from 'braid-design-system';

import { analyticsClient } from 'src/modules/analytics/analytics';
import type { SavedJob } from 'src/types/graphql';
import { getJobStatus } from 'src/utils';

import translations from './ApplyLink.vocab';
interface Props {
  applyLink?: string;
  isExternal?: boolean;
  job: SavedJob;
  index: number;
}

export const ApplyLink = ({
  applyLink,
  isExternal = false,
  job,
  index,
}: Props) => {
  const { t } = useTranslations(translations);
  const hubble = useHubble();

  return (
    <Actions>
      <ButtonLink
        tone="brandAccent"
        href={applyLink || ''}
        target={isExternal ? '_blank' : '_self'}
        icon={isExternal ? <IconNewWindow /> : undefined}
        iconPosition="trailing"
        onClick={() => {
          hubble.trackEvent('job_apply_pressed', {
            jobId: job?.id,
            linkout: isExternal,
          });
          analyticsClient.trackLink({
            eventName: 'job_apply_pressed',
            jobId: job?.id,
            jobListingDate: job.job.createdAt.dateTimeUtc,
            jobLocation: job.job.location.label,
            jobSalary: job.job.salary?.label,
            jobStatus: getJobStatus(job.isActive),
            jobTitle: job.job.title,
            jobIsLinkOut: job.isExternal,
            advertiserName: job.job.advertiser.name,
          });
        }}
        data={{ automation: `apply-link-${index}` }}
      >
        {isExternal ? t('Apply') : t('Quick apply')}
      </ButtonLink>
    </Actions>
  );
};
